import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { Link, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {},
    title: {
        paddingTop: 8,
        margin: '0!important',
        textAlign: 'left!important'
    },
    openButton: {
        cursor: 'pointer'
    },
    button: {
        fontWeight: 600
    },
    contentText: {
        marginBottom: 0,
        '& p:last-of-type': {
            marginBottom: 0
        }
    }
}))

export default function ReadMorePopup({ label, title, children }) {
    const classes = useStyles()
    const [open, setOpen] = useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <Link color="primary" onMouseDown={handleClickOpen} onClick={handleClickOpen} className={classes.openButton}>
                {label}
            </Link>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle disableTypography>
                    <Typography variant={'h5'} className={classes.title}>
                        {title}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.contentText}>{children}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" className={classes.button}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
